import React from "react";

const Quests = () => {

    return (
      <div className="relative min-h-calc-head">
        <div className="wrapper h-dvh">
          <iframe id="sesame-app" src="https://sesamelabs.xyz/metafluence/?tab=home" width="100%" height="100%" frameborder="0"></iframe>
        </div>
      </div>
    )
}

export default Quests;